import { createContext, useContext } from 'react'
import { Theme } from '@/components/theme-provider.tsx'

type ThemeProviderState = {
	appTheme: Theme
	setAppTheme: (theme: Theme, withoutSave: boolean) => void
	themeColor: string
	setThemeColor: (color: string) => void
}

const initialState: ThemeProviderState = {
	appTheme: 'system',
	setAppTheme: () => null,
	themeColor: 'light',
	setThemeColor: () => null,
}

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export const useTheme = () => {
	const context = useContext(ThemeProviderContext)

	if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider')

	return context
}
